export default {
  subjects: null,
  classes: null,
  categories: null,
  assigned: null
}